import React, {createRef} from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';
import {post} from 'Utils/apiUtil';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import OrderShipToDetail from 'Components/commonOrder/OrderShipToDetail';
import OrderBillToDetail from 'Components/commonOrder/OrderBillToDetail';
import OrderPurchaseNo from 'Components/commonOrder/OrderPurchaseNo';
import OrderRemark from 'Components/commonOrder/OrderRemark';
import OrderPromotionCode from 'Components/commonOrder/OrderPromotionCode';
import OrderProductList from 'Components/commonOrder/OrderProductList';
import ProductImage from 'Components/commonOrder/ProductImage';
import SkuInventoryDetailsDialog from 'Components/commonOrder/SkuInventoryDetailsDialog';
import ShippingPlanDialog from 'Components/commonOrder/ShippingPlanDialog';
import BaseImageUploader from 'Components/common/BaseImageUploader';
// Icons
import {Attachment} from '@material-ui/icons';

// Icons
import {ArrowBackIos, NavigateNext} from '@material-ui/icons';

// Actions
import {openNotification} from 'Actions/notification';
import {
    getMyOrderItemDetail,
    cancelOrder,
    getShipments,
    receiveShipment,
    repeatOrder,
    getCustomerAccount,
    setCurrentOrderId,
    setSalesOrderOnholdStatus,
    setFromMyOrderDetails,
    saveShippingPlan,
    getShippingPlanList,
    updateMyOrderDetails,
    updateOrderProofs,
    updateMyOrderProofsLocal,
} from 'Actions/myOrder';
import {
    getSkuInventoryDetails,
    getOrderDetails,
    getShipmentPackageQuantity,
    enterSalesDeliverDetail,
    setCurrentShipmentId,
    notShipOrder,
} from 'Actions/host';
import {getUploadFileLimit} from 'Actions/order';
import {uploadOffineFile} from 'Actions/ltoPurchaseOrder';
import {setUserData, setSCData} from 'Actions/localData';
import {T} from 'Actions/translate';
import {loadLanguage} from 'Utils/jwtUtil';
import {
    ORDER_TYPE,
    PRODUCT_SOURCE,
    USER_ROLE,
    PURCHASE_ORDER_MODE,
    UPLOAD_FILE_LIMIT,
} from 'Utils/constant';

class MyOrderDetail extends React.Component {
    inputFileRef = createRef();
    state = {
        cancelOrderDialogOpened: false,
        previewReceiveImageDialogOpened: false,
        chooseShipmentItem: null,
        receiveShipment: null,
        receiveDialogOpened: false,
        skuInventoryExitOpened: false,
        skuInventoryDetailData: [],
        sQuoteFailureDialogOpened: false,
        orderDisclaimerMessageDialog: false,
        importantNoteMessage: '',

        isOpenShippingPlanDialog: false,
        shippingPlanData: [],
        currentOrderData: '',
        currentOrderProduct: null,
        shippingPlanModalComps: [
            {
                shippingPlanId: 1,
                quantity: 1,
                shippingDate: util.dateFilter(
                    new Date().setDate(new Date().getDate()),
                    'yyyy-MM-dd',
                ),
                remark: '',
            },
        ],
        shippingPlanNum: 1,
        totalShippingQuantity: 0,
        currentTipMessage: '',
        showTip: false,
        uploadCredentialDialogOpened: false,
        chooseImage: null,
        uploadFileLimit: '',
        loading: false,
        uploadedFiles: [],
        uploadLoading: false,
    };

    getEoneHoldLockTypes = (lockType) => {
        const originalLockType = util.getLockedTypeOriginalValue(lockType);
        if (!originalLockType) {
            return [];
        }

        return originalLockType
            .split('&')
            .map((item) => item.trim())
            .filter(Boolean);
    };

    isAnnualAgreementCustomer = () => {
        const {myOrderItemDetail} = this.props;

        return (
            (
                (myOrderItemDetail &&
                    myOrderItemDetail.annualAgreementCustomerFlag) ||
                ''
            ).toUpperCase() === 'Y'
        );
    };

    getOfflineUploadTitle = () =>
        T(
            this.isAnnualAgreementCustomer()
                ? 'lto_purchase_order_upload_purchase_order_for_annual_agreement_customer'
                : 'lto_purchase_order_upload_purchase_order_for_non_annual_agreement_customer',
        );

    isOemOnlyOfflineOrder = () => {
        const {myOrderItemDetail} = this.props;
        const orderProducts =
            (myOrderItemDetail && myOrderItemDetail.orderProducts) || [];

        return (
            myOrderItemDetail &&
            myOrderItemDetail.orderSource === null &&
            myOrderItemDetail.orderType === ORDER_TYPE.SCM &&
            orderProducts.length > 0 &&
            orderProducts.every(
                (orderProduct) =>
                    orderProduct &&
                    orderProduct.product &&
                    orderProduct.product.productSource === PRODUCT_SOURCE.OEM,
            )
        );
    };

    isOemOrderWithoutPrice = () => {
        const {myOrderItemDetail} = this.props;

        return (
            this.isOemOnlyOfflineOrder() &&
            Number(myOrderItemDetail.totalPrice || 0) <= 0
        );
    };

    getOfflineUploadInformation = () =>
        T(
            this.isOemOnlyOfflineOrder()
                ? 'offline_oem_platform_customer_information'
                : 'offline_platform_customer_information',
        );

    getOrderProofTitle = () => {
        const {myOrderItemDetail} = this.props;
        const annualAgreementCustomerFlag = (
            (myOrderItemDetail &&
                myOrderItemDetail.annualAgreementCustomerFlag) ||
            ''
        ).toUpperCase();

        if (annualAgreementCustomerFlag === 'Y') {
            return T('order_detail_purchase_order_voucher_for_po');
        }

        if (annualAgreementCustomerFlag === 'N') {
            return T('order_detail_purchase_order_voucher_for_contract');
        }

        return T('order_detail_purchase_order_voucher');
    };

    componentWillMount() {
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );

        if (
            JSON.stringify(routerState) !== '{}' &&
            typeof routerState.status !== 'undefined' &&
            typeof routerState.orderLockType !== 'undefined' &&
            !this.props.enterSalesDeliverDetails
        ) {
            if (
                parseInt(routerState.status) === 2 ||
                routerState.orderLockType !== 'noLocked' ||
                (parseInt(routerState.status) === 2 &&
                    routerState.orderLockType !== 'noLocked')
            ) {
                this.setState({
                    orderDisclaimerMessageDialog: true,
                    importantNoteMessage:
                        T('host_sales_on_hold_message1') +
                        <b>T('host_sales_on_hold_message2')</b> +
                        T('host_sales_on_hold_message3') +
                        T('host_sales_lock_order_message1') +
                        <b>T('host_sales_lock_order_message2')</b> +
                        T('host_sales_lock_order_message3'),
                });
            } else {
                this.props.getMyOrderItemDetail(this.props.match.params);
                this.props.getShipmentPackageQuantity({
                    orderId: this.props.match.params.id,
                });
            }
        } else if (
            typeof routerState.fromLto !== 'undefined' &&
            routerState.fromLto
        ) {
            this.props
                .getMyOrderItemDetail({orderNumber: routerState.orderNumber})
                .then((res) => {
                    if (res && res.status === 'success' && res.data) {
                        this.props.getShipmentPackageQuantity({
                            orderId: res.data.id,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res);
                    if (res && res.status === 'NO_EXIST') {
                        this.props.openNotification(
                            T('order_does_not_exist'),
                            'danger',
                        );
                    } else {
                        this.props.openNotification(
                            T('order_not_correct'),
                            'danger',
                        );
                    }
                });
        } else {
            this.props.enterSalesDeliverDetail({$set: false});
            this.props.getMyOrderItemDetail(this.props.match.params);
            this.props.getShipmentPackageQuantity({
                orderId: this.props.match.params.id,
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // 如果showTip从false变为true，并且3秒后还没有隐藏，则隐藏它
        if (prevState.showTip === false && this.state.showTip === true) {
            setTimeout(() => {
                this.setState({showTip: false});
            }, 3000);
        }
    }

    getFromLtoFlag = () => {
        let currentFromLto = false;
        if (this.props.location.state && this.props.location.state.fromLto) {
            currentFromLto = this.props.location.state.fromLto;
        }
        return currentFromLto;
    };

    deliverInfor = () => {
        const {myOrderItemDetail} = this.props;

        if (this.props.localData.roleType === 3) {
            if (this.getFromLtoFlag()) {
                this.props.history.push(
                    `/deliverDetails?orderId=${myOrderItemDetail.id}`,
                    {fromSalesOrderDetail: true},
                );
            } else {
                this.props.history.push(
                    `/deliverDetails?orderId=${this.props.match.params.id}`,
                    {fromSalesOrderDetail: true},
                );
            }
        } else {
            if (this.getFromLtoFlag()) {
                this.props.history.push(
                    `/deliverDetails?orderId=${myOrderItemDetail.id}`,
                );
            } else {
                this.props.history.push(
                    `/deliverDetails?orderId=${this.props.match.params.id}`,
                );
            }
        }
    };

    goBack = () => {
        if (this.props.localData.roleType === USER_ROLE.SALES) {
            this.props.setCurrentShipmentId({
                $set: this.props.match.params.id,
            });
        }
        this.props.history.goBack();
    };

    cancelOrder = () => {
        const {myOrderItemDetail} = this.props;
        let orderId = this.getFromLtoFlag()
            ? myOrderItemDetail.id
            : this.props.match.params.id;
        if (orderId) {
            this.props
                .cancelOrder({orderId: orderId}, (res) => {
                    if (res.status === 'success') {
                        res.data.systemCancel
                            ? this.props.openNotification(
                                  T(
                                      'notification_successfully_cancel_the_order',
                                  ),
                                  'success',
                                  {
                                      testid: 'cancel-order-success',
                                  },
                              )
                            : this.props.openNotification(
                                  T(
                                      'notification_cancellation_request_has_been_sent',
                                  ),
                                  'success',
                                  {
                                      testid: 'cancel_request_send_success',
                                  },
                              );

                        this.setState({cancelOrderDialogOpened: false}, () => {
                            this.props.history.replace('/myOrderList/canceled');
                        });
                    } else {
                        this.props.openNotification(
                            T('notification_order_cancellation_failed'),
                            'success',
                        );
                    }
                })
                .catch((err) => {
                    this.setState({cancelOrderDialogOpened: false});
                    if (err.status === 'squote_order_not_allowed') {
                        this.setState({sQuoteFailureDialogOpened: true});
                    }
                });
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };

    openCancelOrderDialog = () => {
        const {myOrderItemDetail} = this.props;
        let orderId = this.getFromLtoFlag()
            ? myOrderItemDetail.id
            : this.props.match.params.id;
        if (orderId) {
            this.setState({cancelOrderDialogOpened: true});
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };
    openReceiveDialog = () => {
        this.props.getShipments(this.props.match.params).then((res) => {
            let shipments = res.data.shipments || [];
            let receiveShipment = null;

            for (let i = 0; i < shipments.length; i++) {
                if (shipments[i].status === 3) {
                    receiveShipment = shipments[i];
                    break;
                }
            }
            this.setState({receiveDialogOpened: true, receiveShipment});
        });
    };

    dialogDidClose = (key) => this.state[key] && this.setState({[key]: false});

    receiveOrder = () => {
        const {receiveShipment} = this.state;

        this.props
            .receiveShipment({shipmentId: receiveShipment.id})
            .then(() => {
                this.props.openNotification(
                    T('notification_successful_receipt_of_goods'),
                    'success',
                );
                this.props.getMyOrderItemDetail(this.props.match.params);
                this.dialogDidClose('receiveDialogOpened');
            });
    };

    buyAgain = (item) => {
        const {localData, myOrderItemDetail} = this.props;
        let orderId = this.getFromLtoFlag()
            ? myOrderItemDetail.id
            : this.props.match.params.id;
        if (orderId) {
            this.props
                .repeatOrder({
                    id: this.getFromLtoFlag()
                        ? myOrderItemDetail.id
                        : this.props.match.params.id,
                    shipToNum: item.shipToNum,
                })
                .then((res) => {
                    if (localData.roleType !== 0) {
                        this.props.setUserData({
                            data: {
                                email: item.email,
                                shipToNum: item.shipToNum,
                                isProxyProcess: true,
                                type: localData.roleType,
                                name: localData.name,
                            },
                        });
                        if (
                            res &&
                            res.data &&
                            res.data.shipToSupplyCenter &&
                            res.data.shipToSupplyCenter.supplyCenterId
                        ) {
                            this.props.setSCData({
                                id: res.data.shipToSupplyCenter.supplyCenterId,
                                name: res.data.shipToSupplyCenter
                                    .supplyCenterName,
                            });
                        } else {
                            this.props.setSCData({
                                id: -1,
                                name: '',
                            });
                        }
                    }

                    this.reOrderSendData(
                        this.getFromLtoFlag()
                            ? myOrderItemDetail.id
                            : this.props.match.params.id,
                    );

                    let tempCustomerName = undefined;
                    if (
                        this.getOrderChannel(item.number) ===
                        PURCHASE_ORDER_MODE.ONLINE
                    ) {
                        this.props
                            .getCustomerAccount({
                                email: item.email,
                                shipToNum: item.shipToNum,
                            })
                            .then((customerAccountRes) => {
                                if (
                                    customerAccountRes &&
                                    customerAccountRes.status === 'success' &&
                                    customerAccountRes.data
                                ) {
                                    tempCustomerName =
                                        customerAccountRes.data.lastName +
                                        customerAccountRes.data.firstName;
                                    this.reOrderGogoShoppingCart(
                                        item,
                                        tempCustomerName,
                                        res.data.shipToSupplyCenter,
                                        res,
                                    );
                                }
                            });
                    } else {
                        this.reOrderGogoShoppingCart(
                            item,
                            tempCustomerName,
                            res.data.shipToSupplyCenter,
                            res,
                        );
                    }
                });
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };

    reOrderGogoShoppingCart = (item, tempCustomerName, supplyCenter, res) => {
        localStorage.setItem(
            'ltoPurchaseOrderMode',
            this.getOrderChannel(item.number),
        );
        localStorage.setItem('purchaseCustomerEmail', item.email);
        localStorage.setItem('purchaseCustomerName', tempCustomerName);
        if (supplyCenter) {
            this.props.history.push('/purchase/shoppingCart', {
                customerEmail: item.email,
                customerName: tempCustomerName,
                fromReorder: true,
                scName: supplyCenter.supplyCenterName,
            });
        } else {
            this.props.history.push('/purchase/shoppingCart', {
                batchAddShipTo: item.shipToNum,
                batchAddEmail: item.email,
                customerEmail: item.email,
                customerName: tempCustomerName,
            });
        }
    };

    getOrderChannel = (orderNumber) => {
        let purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;
        if (orderNumber.startsWith('P')) {
            purchaseOrderMode = PURCHASE_ORDER_MODE.OFFLINE;
        } else if (orderNumber.startsWith('C')) {
            purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;
        }

        return purchaseOrderMode;
    };

    reOrderSendData = (orderId) => {
        this.props.getOrderDetails({id: orderId}).then((res) => {
            let reOrderLists = [];
            if (res && res.status === 'success') {
                let orderProducts = res.data.orderProducts;
                if (orderProducts.length > 0) {
                    orderProducts.map(
                        (orderProductsItem, orderProductsIndex) => {
                            reOrderLists.push({
                                productName:
                                    orderProductsItem.product.productName,
                                sku: orderProductsItem.product.sku,
                                listPrice: orderProductsItem.listPrice,
                                quantity: orderProductsItem.quantity,
                            });
                        },
                    );
                }
            }
        });
    };

    previewReceiveImage = (shipment) =>
        this.setState({
            previewReceiveImageDialogOpened: true,
            chooseShipmentItem: shipment,
        });

    showSkuInventoryDetailHandle = (supplyCenterId, productId, eoneNumber) => {
        this.props
            .getSkuInventoryDetails({
                supplyCenterId: supplyCenterId,
                productId: productId,
                eoneNumber: eoneNumber,
            })
            .then((res) => {
                if (res.status === 'success') {
                    this.openSkuInventoryDetailsDialog(res.data);
                }
            });
    };

    openSkuInventoryDetailsDialog = (name, data, shipData) => {
        this.setState({
            skuInventoryExitOpened: true,
            skuInventoryDetailData: data,
        });
    };

    closeDialog = (name) => {
        if (this.state.skuInventoryExitOpened) {
            this.setState({
                skuInventoryExitOpened: false,
                skuInventoryDetailData: [],
            });
        }
    };

    closeShippingPlanDialog = () => {
        if (this.state.isOpenShippingPlanDialog) {
            this.setState({
                isOpenShippingPlanDialog: false,
                shippingPlanData: [],
                shippingPlanModalComps: [
                    {
                        shippingPlanId: 1,
                        quantity: 1,
                        shippingDate: util.dateFilter(
                            new Date().setDate(new Date().getDate()),
                            'yyyy-MM-dd',
                        ),
                        remark: '',
                    },
                ],
            });
        }
    };

    judgeDeliveryRecord = (myOrderItemDetail, localData) => {
        let isReceivedQuantity = false;

        let orderStatus = myOrderItemDetail.status;
        let partialDelivery = myOrderItemDetail.partialDelivery;

        //当是全部发货或者部分发货时Sales和customer都不能取消订单
        if (localData.roleType === 3 || localData.roleType === 0) {
            if (
                orderStatus === 3 ||
                ((orderStatus === 1 || orderStatus === 2) && partialDelivery)
            ) {
                isReceivedQuantity = true;
            }
        }
        return isReceivedQuantity;
    };

    onCloseImportantNoteMessageHandle = () => {
        const {myOrderItemDetail} = this.props;
        this.setState(
            {
                orderDisclaimerMessageDialog: false,
            },
            () => {
                let orderId = this.getFromLtoFlag()
                    ? myOrderItemDetail.id
                    : this.props.match.params.id;
                if (orderId) {
                    this.props.getMyOrderItemDetail(this.props.match.params);
                    this.props.getShipmentPackageQuantity({
                        orderId: orderId,
                    });
                } else {
                    this.props.openNotification(
                        T('order_does_not_exist'),
                        'danger',
                    );
                }
            },
        );
    };

    showCancelBtn = () => {
        const {localData} = this.props;

        let showCancelBtnFlag = false;
        if (localData.roleType === USER_ROLE.ADMIN) {
            showCancelBtnFlag = true;
        }
        return showCancelBtnFlag;
    };

    previewInvoice = (url) => {
        if (util.isIOS()) {
            window.location.href = url;
        } else {
            window.open(url, '_blank');
        }
    };

    showShippingPlanHandle = (orderData, orderProduct) => {
        let params = {
            orderId: orderData.id,
            sku: orderProduct.product.sku,
            orderProductId: orderProduct.id,
        };
        let planArr = [];
        this.props.getShippingPlanList(params).then((res) => {
            console.log('showShippingPlanHandle-res', res);
            if (
                res &&
                res.status === 'success' &&
                res.data &&
                res.data.items &&
                res.data.items.length > 0
            ) {
                res.data.items.map((planItem) => {
                    planArr.push({
                        id: planItem.id,
                        shippingPlanId: planItem.id,
                        shippingDate: planItem.shippingDate,
                        quantity: planItem.quantity,
                        remark: planItem.remark,
                    });
                });
            } else {
                planArr = this.state.shippingPlanModalComps;
            }
            this.setState({
                isOpenShippingPlanDialog: true,
                currentOrderData: orderData,
                currentOrderProduct: orderProduct,
                shippingPlanData: planArr,
            });
        });
    };

    openNotShipDialog = (item) => {
        this.setState({
            chooseCurrentOrderItem: item,
            notShipDialogOpened: true,
        });
    };

    orderOnHoldHandle = () => {
        const {chooseCurrentOrderItem} = this.state;
        this.props
            .notShipOrder({orderId: chooseCurrentOrderItem.id})
            .then((status) => {
                this.setState(
                    {
                        notShipDialogOpened: false,
                        chooseCurrentOrderItem: '',
                    },
                    () => {
                        this.props.openNotification(
                            T('my_order_on_hold_already_success'),
                            'success',
                            {
                                testid: 'my_order_on_hold_already_success',
                            },
                        );
                        this.props.setSalesOrderOnholdStatus({$set: true});
                        this.props.setCurrentOrderId({
                            $set: parseInt(chooseCurrentOrderItem.id),
                        });
                        this.props.setFromMyOrderDetails({$set: true});

                        let routerState = util.getRouterState(
                            this.props.history.location.state,
                        );

                        let currentOrderNumber = null;
                        if (
                            typeof routerState.fromLto !== 'undefined' &&
                            routerState.fromLto
                        ) {
                            currentOrderNumber = {
                                orderNumber: routerState.orderNumber,
                            };
                        } else {
                            currentOrderNumber = this.props.match.params;
                        }
                        this.props.getMyOrderItemDetail(currentOrderNumber);

                        this.props.getShipmentPackageQuantity({
                            orderId: chooseCurrentOrderItem.id,
                        });
                    },
                );
            })
            .catch((res) => {
                if (res && res.message) {
                    if (res.message === 'Black_Sku') {
                        this.setState({
                            notShipDialogOpened: false,
                            chooseCurrentOrderItem: '',
                        });
                        this.props.openNotification(
                            T(
                                'grey_list_products_can_not_be_temporarily_shipped',
                            ),
                            'danger',
                        );
                    }
                }
            });
    };

    saveShippingPlanHandle = (currentOrderProduct, myOrderData) => {
        let {shippingPlanData} = this.state;
        let params = {
            orderId: myOrderData.id,
            orderNumber: myOrderData.number,
            orderProductId: currentOrderProduct.id,
            sku: currentOrderProduct.product.sku,
            items: util.getShippingPlanParam(shippingPlanData),
        };
        if (util.isShippingDateNull(shippingPlanData).isQuantityFlag) {
            this.setState({
                showTip: true,
                currentTipMessage: 'shipping_plan_shipped_quantity_not_null',
            });
        } else if (
            util.isShippingDateNull(shippingPlanData).isShippingDateFlag
        ) {
            this.setState({
                showTip: true,
                currentTipMessage: 'shipping_plan_shipped_date_not_null',
            });
        } else {
            if (
                this.getAddedQuantityOfShippingPlans() <=
                currentOrderProduct.quantity
            ) {
                if (util.isRequireSubmit(shippingPlanData)) {
                    this.props.saveShippingPlan(params).then((res) => {
                        if (res && res.status === 'success') {
                            this.props.updateMyOrderDetails({
                                $set: util.updateCurrentShippingPlanFlag(
                                    currentOrderProduct,
                                    myOrderData,
                                ),
                            });

                            this.props.openNotification(
                                T('shipping_plan_add_success'),
                                'success',
                            );

                            this.closeShippingPlanDialog();
                        }
                    });
                } else {
                    this.closeShippingPlanDialog();
                }
            } else {
                this.setState({
                    showTip: true,
                    currentTipMessage:
                        'shipping_plan_quantity_cannot_exceed_total_quantity_SKUs',
                });
            }
        }
    };

    isDeletePlanFlag = (deleteShippingId) => {
        let {shippingPlanData} = this.state;
        let isDeleteFlag = true;
        if (shippingPlanData.length > 0) {
            shippingPlanData.map((planItem) => {
                if (
                    planItem.id &&
                    planItem.shippingPlanId === deleteShippingId
                ) {
                    isDeleteFlag = false;
                }
            });
        }

        return isDeleteFlag;
    };

    deleteShippingPlanHandle = (comps) => {
        let {shippingPlanData} = this.state;
        if (!this.isDeletePlanFlag(comps)) {
            this.setState({
                showTip: true,
                currentTipMessage: 'shipping_plan_added_plan_cannot_delete',
            });
        } else {
            if (shippingPlanData.length > 1) {
                shippingPlanData.splice(
                    shippingPlanData.findIndex(
                        (item) => item.shippingPlanId === comps,
                    ),
                    1,
                );

                this.setState({
                    shippingPlanData: shippingPlanData,
                });
            } else {
                this.setState({
                    showTip: true,
                    currentTipMessage: 'shipping_plan_needed_one_plan',
                });
            }
        }
    };

    addShippingPlanItemHandle = (skuQuantity) => {
        let {shippingPlanData, shippingPlanNum} = this.state;

        if (this.getAddedQuantityOfShippingPlans() < skuQuantity) {
            shippingPlanData.push({
                shippingPlanId: shippingPlanNum + 1,
                quantity: 1,
                shippingDate: util.dateFilter(
                    new Date().setDate(new Date().getDate()),
                    'yyyy-MM-dd',
                ),
                remark: '',
            });

            this.setState({
                shippingPlanData: shippingPlanData,
                shippingPlanNum: ++shippingPlanNum,
            });
        } else {
            this.setState({
                showTip: true,
                currentTipMessage:
                    'shipping_plan_quantity_cannot_exceed_total_quantity_SKUs',
            });
        }
    };

    eidtShippingDateHandle = (title, value) => {
        let number = parseInt(title.split('-')[1]);
        let currentshippingPlanData = JSON.parse(
            JSON.stringify(this.state.shippingPlanData),
        );
        currentshippingPlanData.forEach((shippingPlanModal, skuIndex) => {
            if (number === shippingPlanModal.shippingPlanId) {
                shippingPlanModal.shippingDate = value;
            }
        });
        this.setState({
            [title]: value,
            shippingPlanData: currentshippingPlanData,
        });
    };

    eidtShippingPlanRQuantityHandle = (value, currentIndex) => {
        console.log(
            'value, currentIndex, eidtShippingPlanRQuantityHandle',
            value,
            currentIndex,
        );
        let currentValue = value;
        if (value && util.isString(value)) {
            currentValue = parseInt(value);
        }
        this.setState((prevState) => {
            const currentShippingPlanData = prevState.shippingPlanData.map(
                (shippingPlanModal) => {
                    if (currentIndex === shippingPlanModal.shippingPlanId) {
                        return {
                            ...shippingPlanModal,
                            quantity: currentValue,
                        };
                    }
                    return shippingPlanModal;
                },
            );

            return {
                shippingPlanData: currentShippingPlanData,
            };
        });
    };

    getAddedQuantityOfShippingPlans = () => {
        let currentshippingPlanData = JSON.parse(
            JSON.stringify(this.state.shippingPlanData),
        );

        let addedShippingPlanQuantity = 0;
        currentshippingPlanData.length > 0 &&
            currentshippingPlanData.map((shippingPlanItem) => {
                addedShippingPlanQuantity += shippingPlanItem.quantity;
            });

        return addedShippingPlanQuantity;
    };

    openUploadCredentialDialog = () => {
        let tempFileLimit = '';
        let tempMaxFileSize = 0;
        this.props
            .getUploadFileLimit(UPLOAD_FILE_LIMIT.FILE_LIMIT)
            .then((res) => {
                if (
                    res &&
                    res.payload &&
                    res.payload.status === 'success' &&
                    res.payload.data
                ) {
                    res.payload.data.length > 0 &&
                        res.payload.data.map((fileItem) => {
                            if (fileItem.key === 'allowFileExtensions') {
                                tempFileLimit = fileItem.value
                                    ? fileItem.value.join(',')
                                    : '';
                            }
                            if (fileItem.key === 'maxFileSize') {
                                tempMaxFileSize = fileItem.value;
                            }
                        });
                    this.setState({
                        uploadFileLimit: tempFileLimit,
                        currentMaxFileSize: tempMaxFileSize,
                    });
                }
            });
        this.setState({
            uploadCredentialDialogOpened: true,
        });
    };

    closeUploadCredentialDialog = () => {
        this.inputFileRef.current.value = null;
        this.setState({
            uploadCredentialDialogOpened: false,
            chooseImage: null,
            uploadedFiles: [],
            uploadLoading: false,
        });
    };

    deleteUploadedFile = (deleteIndex) => {
        this.setState((prevState) => ({
            uploadedFiles: (prevState.uploadedFiles || []).filter(
                (item, index) => index !== deleteIndex,
            ),
        }));
    };

    uploadConfirmHandle = async () => {
        const {myOrderItemDetail} = this.props;
        const {uploadedFiles} = this.state;
        const id = myOrderItemDetail.id;

        if (!id) {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
            return;
        }

        if (!uploadedFiles || uploadedFiles.length === 0) {
            this.props.openNotification(
                T('notification_upload_at_least_one_proof'),
                'danger',
            );
            return;
        }

        try {
            const res = await this.props.updateOrderProofs({
                orderId: id,
                orderProofs: uploadedFiles,
            });

            if (res && res.status === 'success') {
                this.props.openNotification(
                    T('notification_update_proof_success'),
                    'success',
                );
                this.closeUploadCredentialDialog();
                await this.props.getMyOrderItemDetail(this.props.match.params);
            } else {
                this.props.openNotification(
                    T('notification_picture_upload_failed'),
                    'danger',
                );
            }
        } catch (e) {
            this.props.openNotification(
                T('notification_picture_upload_failed'),
                'danger',
            );
        }
    };

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;

        const reader = new FileReader();
        const file = ev.target.files[0];

        if (file) {
            this.setState({uploadLoading: true});
            reader.onload = (loadEv) => {
                const previewUrl = loadEv.target.result;
                (async () => {
                    try {
                        const res = await this.props.uploadOffineFile({
                            type: 'offline_order',
                            file,
                        });
                        if (res && res.status === 'success') {
                            // If the dialog was closed while upload was in-flight, ignore this result
                            if (!this.state.uploadCredentialDialogOpened) {
                                return;
                            }
                            const fileObj = {
                                url: res.url,
                                name: res.name,
                            };
                            this.setState((prevState) => ({
                                chooseImage: {
                                    file,
                                    url: res.url || previewUrl,
                                    name: res.name || file.name,
                                },
                                uploadedFiles: [
                                    ...(prevState.uploadedFiles || []),
                                    fileObj,
                                ],
                            }));
                            this.props.openNotification(
                                T('offline_order_successfully_upload'),
                                'success',
                            );
                        } else {
                            this.setState({
                                chooseImage: null,
                            });
                            this.props.openNotification(
                                T('notification_picture_upload_failed'),
                                'danger',
                            );
                        }
                    } catch (e) {
                        this.setState({chooseImage: null});
                    } finally {
                        this.setState({uploadLoading: false});
                        this.inputFileRef.current &&
                            (this.inputFileRef.current.value = null);
                    }
                })();
            };

            reader.readAsDataURL(file);
        }
    };

    chooseImage = (item) => {
        this.inputFileRef.current.click();
    };

    render() {
        const {
            cancelOrderDialogOpened,
            previewReceiveImageDialogOpened,
            receiveDialogOpened,
            chooseShipmentItem,
            receiveShipment,
            skuInventoryExitOpened,
            sQuoteFailureDialogOpened,
            orderDisclaimerMessageDialog,
            notShipDialogOpened,
            isOpenShippingPlanDialog,
            currentOrderData,
            currentOrderProduct,
            shippingPlanData,
            totalShippingQuantity,
            currentTipMessage,
            showTip,
            uploadCredentialDialogOpened,
            chooseImage,
            uploadFileLimit,
            loading,
            uploadLoading,
        } = this.state;
        const {
            myOrderItemDetail,
            localData,
            skuInventoryDetails,
            packageQuantity,
        } = this.props;
        const eoneHoldLockTypes = this.getEoneHoldLockTypes(
            myOrderItemDetail.lockType,
        );
        let isShipped = false;
        let showShipments = false;
        const isHaveShipmentImage =
            chooseShipmentItem && chooseShipmentItem.receiveImg;

        myOrderItemDetail.orderProducts &&
            myOrderItemDetail.orderProducts.forEach((product) => {
                if (product.shippedQuantity > 0) isShipped = true;
            });

        myOrderItemDetail.shipments &&
            myOrderItemDetail.shipments.forEach((shipment) => {
                if (shipment.expressNumber) showShipments = true;
                if (shipment.status === 4) showShipments = true;
            });

        let isReceivedQuantity = this.judgeDeliveryRecord(
            myOrderItemDetail,
            localData,
        );
        let lang = loadLanguage();
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );

        return (
            <div className="my-order-detail-container">
                {typeof orderDisclaimerMessageDialog !== 'undefined' &&
                !orderDisclaimerMessageDialog ? (
                    <div>
                        <div
                            className={util.getClassName({
                                'header-wrap':
                                    true &&
                                    (myOrderItemDetail.lockType === 'unLock' ||
                                        myOrderItemDetail.lockType === 'No' ||
                                        !myOrderItemDetail.lockType),
                                'lock-header-wrap':
                                    true &&
                                    lang !== 'EN' &&
                                    util.getLockedType(myOrderItemDetail) ===
                                        'checking',
                                'credit-lock-header-wrap':
                                    true &&
                                    lang !== 'EN' &&
                                    (util.getLockedType(myOrderItemDetail) ===
                                        'financialLocked' ||
                                        util.getLockedType(
                                            myOrderItemDetail,
                                        ) === 'addingC2Locked'),
                                'en-lock-header-wrap':
                                    true &&
                                    lang === 'EN' &&
                                    util.getLockedType(myOrderItemDetail) ===
                                        'checking',
                                'en-credit-lock-header-wrap':
                                    true &&
                                    lang === 'EN' &&
                                    (util.getLockedType(myOrderItemDetail) ===
                                        'financialLocked' ||
                                        util.getLockedType(
                                            myOrderItemDetail,
                                        ) === 'addingC2Locked'),
                            })}>
                            <h3 className="my-order-detail-header container-max-width is-fixed">
                                <Anchor
                                    className="go-back"
                                    onClickOfSingleTap={this.goBack}>
                                    <ArrowBackIos />
                                </Anchor>
                                {T('order_details')}
                            </h3>
                            {util.getLockedType(myOrderItemDetail) ===
                                'checking' ||
                            util.getLockedType(myOrderItemDetail) ===
                                'financialLocked' ||
                            util.getLockedType(myOrderItemDetail) ===
                                'addingC2Locked' ? (
                                <div className="notice-lock container-max-width is-fixed">
                                    <div className="notice-lock-text">
                                        {T(
                                            util.getLockedTypeMessage(
                                                myOrderItemDetail,
                                            ),
                                        )}
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        <div className="content-box">
                            <p className="supply-center-name">
                                <label>{T('supplyCenter')}</label>{' '}
                                {myOrderItemDetail.scName
                                    ? myOrderItemDetail.scName
                                    : T('order_no_name')}
                            </p>
                            <p
                                className="order-number"
                                testid="order-detail-number">
                                <label>{T('shippment_order_number')}</label>{' '}
                                {myOrderItemDetail.number}
                            </p>
                            <p className="EONE-order-number">
                                <label>{T('shippment_eone_number')}</label>{' '}
                                {myOrderItemDetail.eoneNumber}
                            </p>
                            {localData.roleType == USER_ROLE.HOST ? (
                                <p className="delivery-method-area">
                                    <label>{T('order_delivery_method')}</label>{' '}
                                    {myOrderItemDetail.actualTransportMethod
                                        ? myOrderItemDetail.actualTransportMethod ===
                                          'Direct'
                                            ? T('direct_method')
                                            : T('mail_method')
                                        : T('order_no_name')}
                                </p>
                            ) : null}
                            {eoneHoldLockTypes.length > 0 ? (
                                <p className="EONE-order-status eone-hold">
                                    <label>{T('order_eone_hold')}</label>{' '}
                                    <span
                                        className="eone-hold-tags"
                                        testid="order-detail-status">
                                        {eoneHoldLockTypes.map(
                                            (lockType, index) => (
                                                <span
                                                    className="eone-hold-tag"
                                                    key={`${lockType}-${index}`}>
                                                    {lockType}
                                                </span>
                                            ),
                                        )}
                                    </span>
                                </p>
                            ) : null}
                            {myOrderItemDetail.status !== -1 ? (
                                <p className="buy-time">
                                    <label>
                                        {T('shippment_purchase_date')}
                                    </label>
                                    {myOrderItemDetail.createTime}
                                </p>
                            ) : null}
                            {myOrderItemDetail.status === -1 ? (
                                <p className="cancel-time">
                                    <label>{T('shippment_cancel_date')}</label>
                                    {myOrderItemDetail.cancelTime}
                                </p>
                            ) : null}
                        </div>

                        {myOrderItemDetail.orderType === 'SCM' ? (
                            <div className="shipped-detail-container">
                                <h4 className="ship-to-detail-title">
                                    <div className="deliver-title">
                                        {T('shippment_delivery_details')}
                                    </div>
                                    <div
                                        className="deliver-quantity"
                                        onClick={this.deliverInfor}>
                                        {T('shipment_delivered_package_count', [
                                            packageQuantity &&
                                                typeof packageQuantity.data !==
                                                    'undefined' &&
                                                packageQuantity.data,
                                        ])}
                                        <NavigateNext className="navigate-next-icon" />
                                    </div>
                                </h4>
                            </div>
                        ) : null}

                        {myOrderItemDetail.orderProofs &&
                        myOrderItemDetail.orderProofs.length > 0 ? (
                            <div className="purchase-order-voucher-container">
                                <h4 className="purchase-order-voucher-title">
                                    <div className="purchase-order-title">
                                        {this.getOrderProofTitle()}
                                    </div>
                                </h4>
                                <div className="purchase-order-voucher-file-container">
                                    {myOrderItemDetail.orderProofs.map(
                                        (proofItem, proofIndex) => (
                                            <div className="purchase-order-voucher-file">
                                                <div className="card-label">
                                                    {/* {T(
                                                        'lto_purchase_upload_file',
                                                        [++proofIndex],
                                                    )} */}
                                                    {proofItem.name}
                                                </div>
                                                <a
                                                    className="btn"
                                                    href={proofItem.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    {T(
                                                        'order_detail_purchase_order_voucher_preview',
                                                    )}
                                                </a>
                                            </div>
                                        ),
                                    )}
                                </div>
                            </div>
                        ) : null}

                        {/* 新增：离线客户上传凭证展示 */}
                        {(!myOrderItemDetail.orderProofs ||
                            myOrderItemDetail.orderProofs.length === 0) &&
                        myOrderItemDetail.orderSource === null &&
                        (Number(myOrderItemDetail.totalPrice || 0) > 60000 ||
                            this.isOemOrderWithoutPrice()) ? (
                            <div className="purchase-order-attachment-container no-margin">
                                <div className="order-card">
                                    <div className="purchase-order-radio">
                                        <div
                                            className="purchase-order-radio-item"
                                            testid={
                                                this.isAnnualAgreementCustomer()
                                                    ? 'my-order-annual-customer-title'
                                                    : 'my-order-non-annual-customer-title'
                                            }>
                                            {this.getOfflineUploadTitle()}
                                        </div>
                                        <div className="upload-order-message">
                                            <div>
                                                {this.getOfflineUploadInformation()}
                                            </div>
                                        </div>
                                        <div
                                            className="upload-attachment-container"
                                            testid={
                                                this.isAnnualAgreementCustomer()
                                                    ? 'my-order-annual-customer-upload-attachment'
                                                    : 'my-order-non-annual-customer-upload-attachment'
                                            }
                                            onClick={() =>
                                                this.openUploadCredentialDialog()
                                            }>
                                            <Attachment />
                                            {T(
                                                'offline_platform_customer_add_attachment',
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        <OrderShipToDetail
                            className="detail-box"
                            data={myOrderItemDetail}></OrderShipToDetail>
                        <OrderBillToDetail
                            className="detail-box"
                            data={myOrderItemDetail}></OrderBillToDetail>
                        {/* {
                        myOrderItemDetail.orderType !== 'TFS' && showShipments ?
                        <ul className="shipment-list detail-box">
                            {
                                myOrderItemDetail.shipments && myOrderItemDetail.shipments.map((item, index) => (
                                    <li className="shipment-item" key={ index }>
                                        {
                                            item.status === 4 ?
                                            <div className="shipment-files">
                                                <span className="shipment-receive-image"><label>{T('order_sign_receipt')}</label> <Anchor className="btn" onClickOfSingleTap={ () => this.previewReceiveImage(item) }>{T('order_preview')}</Anchor></span>
                                            </div> : null
                                        }
                                        {
                                            item.expressNumber ?
                                            <p className="express-number"><label>{T('order_express_number')}</label>{ item.expressNumber }</p>
                                            : null
                                        }
                                        {
                                            item.status === 4 ?
                                            <p className="received-time"><label>{T('order_sign_date')}</label>{ item.receivedTime }</p>
                                            : null
                                        }
                                    </li>
                                ))
                            }
                        </ul>
                        : null
                    } */}
                        <OrderPurchaseNo
                            className="order-purchase-no"
                            purchaseNo={
                                myOrderItemDetail.purchaseNo
                            }></OrderPurchaseNo>
                        <OrderRemark
                            className={util.getClassName({
                                'order-remark': true && lang !== 'EN',
                                'en-order-remark': true && lang === 'EN',
                            })}
                            remark={myOrderItemDetail.remark}></OrderRemark>
                        {localData.roleType !== 2 &&
                        myOrderItemDetail &&
                        myOrderItemDetail.orderProducts ? (
                            // myOrderItemDetail.orderProducts[0].promotionCode !== '' &&
                            // myOrderItemDetail.orderProducts[0].promotionCode !== null ?
                            <OrderPromotionCode
                                className={util.getClassName({
                                    'order-promotion-code':
                                        true && lang !== 'EN',
                                    'en-order-promotion-code':
                                        true && lang === 'EN',
                                })}
                                promotionCode={
                                    myOrderItemDetail.promoCodes
                                }></OrderPromotionCode>
                        ) : null}
                        <OrderProductList
                            className="products"
                            data={myOrderItemDetail}
                            options={{
                                inventoryKey: 'displayInventory',
                                showQuantity:
                                    myOrderItemDetail.orderType !== 'TFS',
                            }}
                            roleType={localData.roleType}
                            tabFlag={null}
                            openShippingPlan={this.showShippingPlanHandle}
                            showSkuInventoryDetailHandle={
                                this.showSkuInventoryDetailHandle
                            }></OrderProductList>

                        <div className="footer-warp">
                            <div
                                className={
                                    this.showCancelBtn()
                                        ? 'my-order-detail-footer container-max-width is-fixed'
                                        : 'my-order-detail-footer container-max-width is-fixed one-button-on-footer'
                                }>
                                {this.showCancelBtn() ? (
                                    <div>
                                        {myOrderItemDetail.status === -1 ||
                                        myOrderItemDetail.status === 4 ||
                                        (myOrderItemDetail.adminId !==
                                            localData.id &&
                                            localData.roleType === 3) ||
                                        isReceivedQuantity ? null : (
                                            <BasicButton
                                                className="cancel-btn"
                                                testid="cancel-order-btn"
                                                type="info"
                                                onClickOfSingleTap={
                                                    this.openCancelOrderDialog
                                                }>
                                                {T('order_cancel_order')}
                                            </BasicButton>
                                        )}
                                    </div>
                                ) : null}
                                <div>
                                    {myOrderItemDetail.orderType === 'SCM' &&
                                    (myOrderItemDetail.status === 3 ||
                                        myOrderItemDetail.status === 2 ||
                                        myOrderItemDetail.status === 1) &&
                                    localData.roleType === 0 &&
                                    isShipped ? (
                                        <BasicButton
                                            className="receipt-btn"
                                            testid="receipt-order-btn"
                                            type="primary"
                                            onClickOfSingleTap={
                                                this.openReceiveDialog
                                            }>
                                            {myOrderItemDetail.partialDelivery
                                                ? T('order_partial_receipt')
                                                : T('order_full_receipt')}
                                        </BasicButton>
                                    ) : null}

                                    {myOrderItemDetail &&
                                        myOrderItemDetail.orderProducts &&
                                        myOrderItemDetail.orderProducts.length >
                                            0 &&
                                        util.isShowBtn(
                                            myOrderItemDetail.orderProducts,
                                        ) && (
                                            <BasicButton
                                                className="buy-again-btn"
                                                testid="my_order_detail_buy_again_btn"
                                                type="primary"
                                                onClickOfSingleTap={this.buyAgain.bind(
                                                    this,
                                                    myOrderItemDetail,
                                                )}>
                                                {T('order_buy_again')}
                                            </BasicButton>
                                        )}

                                    {myOrderItemDetail.orderType === 'SCM' &&
                                    myOrderItemDetail.status === 1 ? (
                                        <BasicButton
                                            className="my-order-onhold-btn"
                                            testid="my_order_detail_onhold_btn"
                                            type="primary"
                                            onClickOfSingleTap={() =>
                                                this.openNotShipDialog(
                                                    myOrderItemDetail,
                                                )
                                            }>
                                            {T('my_order_on_hold')}
                                        </BasicButton>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                <Dialog
                    opened={cancelOrderDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelOrderDialogOpened')
                    }
                    testid="my_order_detail_cancel_order_dialog"
                    options={{bgClickClose: true}}>
                    {myOrderItemDetail.orderType === 'SCM' ? (
                        <div className="cancel-order-dialog">
                            <h5 className="cancel-order-dialog-title text-center">
                                {T('order_cancel_order')}
                            </h5>
                            <p className="cancel-order-dialog-desc text-center">
                                {T('order_confirm_cancel_order')}
                            </p>
                            <BasicButton
                                type="primary"
                                testid="my_order_detail_cancel_order_dialog_confirm_btn"
                                className="cancel-order-confirm-btn"
                                onClickOfSingleTap={this.cancelOrder}>
                                {T('order_confirm')}
                            </BasicButton>
                        </div>
                    ) : (
                        <div className="cancel-order-dialog">
                            <h5 className="cancel-order-dialog-title text-center">
                                {T('order_cancel_order')}
                            </h5>
                            <div className="cancel-order-dialog-desc text-center">
                                <p>{T('order_cancel_order_by_service')}</p>
                                <p>{T('order_service_email')}</p>
                            </div>
                        </div>
                    )}
                </Dialog>
                <Dialog
                    opened={previewReceiveImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewReceiveImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className={`preview-shipment-receive-image-dialog ${
                            !isHaveShipmentImage
                                ? 'shipment-receive-image-no-image'
                                : ''
                        }`}>
                        {chooseShipmentItem && chooseShipmentItem.receiveImg ? (
                            <img
                                src={
                                    util.getImageRoot() +
                                    chooseShipmentItem.receiveImg
                                }
                                alt={
                                    util.getImageRoot() +
                                    chooseShipmentItem.receiveImg
                                }
                            />
                        ) : (
                            T('order_not_upload_sign_receipt')
                        )}
                    </div>
                </Dialog>
                <Dialog
                    opened={receiveDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('receiveDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="receive-order-confirm-dialog">
                        <h5>
                            {myOrderItemDetail.partialDelivery
                                ? T('order_partial_receipt_confirm')
                                : T('order_full_receipt_confirm')}
                        </h5>
                        <ul className="product-list">
                            {receiveShipment &&
                                receiveShipment.shipmentProducts &&
                                receiveShipment.shipmentProducts.map((item) =>
                                    item.shippedQuantity > 0 ? (
                                        <li>
                                            <p
                                                className="product-name"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item.product &&
                                                        item.product
                                                            .productName,
                                                }}
                                            />
                                            <div className="details">
                                                <div className="image-box">
                                                    <ProductImage
                                                        src={
                                                            item.product &&
                                                            item.product
                                                                .productPic
                                                        }
                                                        alt={
                                                            item.product &&
                                                            item.product
                                                                .productName
                                                        }
                                                        key={
                                                            item.product &&
                                                            item.product
                                                                .productPic
                                                        }
                                                    />
                                                </div>
                                                <div className="details-text">
                                                    <p className="text-ellipsis">
                                                        {T(
                                                            'product_specifications_colon',
                                                        )}
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    item.product &&
                                                                    item.product
                                                                        .specifications,
                                                            }}
                                                        />
                                                    </p>
                                                    <p className="text-ellipsis">
                                                        {T(
                                                            'not_shippment_quantity_colon',
                                                        )}{' '}
                                                        {item.tobeshippedQuantity ||
                                                            item.onholdQuantity}
                                                    </p>
                                                    <p className="point text-ellipsis">
                                                        {T(
                                                            'order_current_shippment_number_colon',
                                                        )}{' '}
                                                        {item.quantity}
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    ) : null,
                                )}
                        </ul>
                        <BasicButton
                            type="primary"
                            className="confirm-btn"
                            testid="confirm-receive-btn"
                            onClickOfSingleTap={this.receiveOrder}>
                            {T('order_confirm_receive')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={sQuoteFailureDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('sQuoteFailureDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    {
                        <div className="cancel-order-dialog">
                            <h5 className="cancel-order-dialog-title text-center">
                                {T('order_cancel_order')}
                            </h5>
                            <div className="cancel-order-dialog-desc text-center">
                                <p>
                                    {localData.roleType == 0
                                        ? T(
                                              'order_quote_order_by_service_customer',
                                          )
                                        : T('order_quote_order_by_service')}
                                </p>
                                <p>{T('order_service_email')}</p>
                            </div>
                        </div>
                    }
                </Dialog>
                <SkuInventoryDetailsDialog
                    skuReplenishmentDetailData={skuInventoryDetails}
                    closeDialog={this.closeDialog}
                    opened={skuInventoryExitOpened}
                    isOperateFlag="ship"
                />
                <ShippingPlanDialog
                    skuReplenishmentDetailData={skuInventoryDetails}
                    myOrderData={myOrderItemDetail}
                    closeDialog={this.closeShippingPlanDialog}
                    opened={isOpenShippingPlanDialog}
                    addedShippingPlanData={shippingPlanData}
                    currentOrderProduct={currentOrderProduct}
                    saveShippingPlan={this.saveShippingPlanHandle}
                    deleteShippingPlan={this.deleteShippingPlanHandle}
                    addShippingPlanItem={this.addShippingPlanItemHandle}
                    currentTipMessage={currentTipMessage}
                    showTip={showTip}
                    eidtShippingDate={this.eidtShippingDateHandle}
                    eidtShippingPlanRQuantity={
                        this.eidtShippingPlanRQuantityHandle
                    }
                    isOperateFlag="addShippingPlan"
                />

                <Dialog opened={orderDisclaimerMessageDialog}>
                    <div className="important-note-dialog">
                        <h5 className="important-note-dialog-title text-center">
                            {T('host_sales_important_note_message')}
                        </h5>
                        <p className="important-note-content-container text-center">
                            <div className="important-note-infor">
                                {parseInt(routerState.status) === 2 &&
                                routerState.orderLockType !== 'noLocked' ? (
                                    <div className="important-note">
                                        <label>
                                            {T('host_sales_on_hold_message1')}
                                            <b>
                                                {T(
                                                    'host_sales_on_hold_message2',
                                                )}
                                            </b>
                                            {T('host_sales_on_hold_message3')}
                                        </label>
                                        <label className="order-two-message">
                                            {T(
                                                'host_sales_lock_order_message1',
                                            )}
                                            <b>
                                                {T(
                                                    'host_sales_lock_order_message2',
                                                )}
                                            </b>
                                            {T(
                                                'host_sales_lock_order_message3',
                                            )}
                                        </label>
                                    </div>
                                ) : null}
                                {parseInt(routerState.status) !== 2 &&
                                routerState.orderLockType !== 'noLocked' ? (
                                    <div className="important-note">
                                        {/* <label>
                                            {T('host_sales_lock_order_message')}
                                        </label> */}
                                        <label className="order-two-message">
                                            {T(
                                                'host_sales_lock_order_message1',
                                            )}
                                            <b>
                                                {T(
                                                    'host_sales_lock_order_message2',
                                                )}
                                            </b>
                                            {T(
                                                'host_sales_lock_order_message3',
                                            )}
                                        </label>
                                    </div>
                                ) : null}
                                {parseInt(routerState.status) === 2 &&
                                routerState.orderLockType === 'noLocked' ? (
                                    <div className="important-note">
                                        {/* <label>
                                            {T('host_sales_on_hold_message')}
                                        </label> */}
                                        <label>
                                            {T('host_sales_on_hold_message1')}
                                            <b>
                                                {T(
                                                    'host_sales_on_hold_message2',
                                                )}
                                            </b>
                                            {T('host_sales_on_hold_message3')}
                                        </label>
                                    </div>
                                ) : null}
                            </div>
                        </p>
                        <div className="important-note-btn-container">
                            <BasicButton
                                type="primary"
                                className="important-note-close-btn"
                                testid="important-note-close-btn"
                                onClickOfSingleTap={
                                    this.onCloseImportantNoteMessageHandle
                                }>
                                {T('host_sales_important_note_close')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={notShipDialogOpened}
                    testid="my_order_detail_onhold_dialog"
                    dialogDidClose={() =>
                        this.dialogDidClose('notShipDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="not-ship-dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_temporary_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_temporary_delivery')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            testid="my_order_detail_onhold_dialog_confirm_btn"
                            className="not-ship-confirm-btn"
                            onClickOfSingleTap={this.orderOnHoldHandle}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={uploadCredentialDialogOpened}
                    notSetDialogTop={true}
                    dialogId="offlineUploadCredential"
                    dialogDidClose={() => this.closeUploadCredentialDialog()}
                    options={{bgClickClose: true}}>
                    <div className="upload-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {T('lto_purchase_upload_file_confirm_upload_tag')}
                        </h5>
                        <div className="upload-file-format">
                            {T('upload_file_format', [uploadFileLimit])}
                        </div>
                        <div className="credential-tag-upload-dialog-desc text-center">
                            <BaseImageUploader
                                className={util.getClassName({
                                    'upload-method-upload text-center text-ellipsis':
                                        true && lang !== 'EN',
                                    'en-upload-method-upload text-center text-ellipsis':
                                        true && lang === 'EN',
                                })}
                                id={
                                    chooseImage &&
                                    chooseImage.url &&
                                    chooseImage.file &&
                                    chooseImage.file.type.indexOf('image/') ===
                                        -1
                                        ? 'notImageType'
                                        : ''
                                }
                                onClickOfSingleTap={this.chooseImage}>
                                <>
                                    <span className="upload-method-upload-icon" />
                                    <span className="upload-method-upload-text">
                                        {T('purchase_order_upload_here')}
                                    </span>
                                </>
                                <input
                                    // ref="inputFile"
                                    ref={this.inputFileRef}
                                    type="file"
                                    onChange={this.selectedImage}
                                />
                            </BaseImageUploader>
                            {uploadLoading ? (
                                <div className="uploading-spinner">
                                    {T('uploading')}...
                                </div>
                            ) : null}
                            {this.state.uploadedFiles &&
                            this.state.uploadedFiles.length > 0 ? (
                                <div className="credential-file-preview">
                                    {this.state.uploadedFiles.map(
                                        (fileItem, index) => (
                                            <div
                                                className="credential-file-row"
                                                key={fileItem.url || index}>
                                                <div className="credential-file-name">
                                                    {fileItem.name}
                                                </div>
                                                <Anchor
                                                    className="delete-attachment"
                                                    onClickOfSingleTap={() =>
                                                        this.deleteUploadedFile(
                                                            index,
                                                        )
                                                    }>
                                                    {T(
                                                        'shopping_cart_delete_button',
                                                    )}
                                                </Anchor>
                                            </div>
                                        ),
                                    )}
                                </div>
                            ) : null}
                        </div>
                        <div className="upload-method-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                onClickOfSingleTap={() =>
                                    this.uploadConfirmHandle()
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                className="upload-method-cancel"
                                onClickOfSingleTap={() =>
                                    this.closeUploadCredentialDialog()
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {myOrder, localData, host} = state;

    return {
        myOrderItemDetail: myOrder.myOrderItemDetail,
        skuInventoryDetails: host.skuInventoryDetails,
        localData,
        packageQuantity: host.packageQuantity,
        enterSalesDeliverDetails: host.enterSalesDeliverDetails,

        salesOnholdStatusFlag: myOrder.salesOnholdStatusFlag,
        currentOrderId: myOrder.currentOrderId,
        currentPageNum: myOrder.currentPageNum,

        shippingPlanDetails: myOrder.shippingPlanDetails,
    };
};

const mapDispatchToProps = {
    getMyOrderItemDetail,
    openNotification,
    cancelOrder,
    getShipments,
    repeatOrder,
    getCustomerAccount,
    setUserData,
    receiveShipment,
    setSCData,
    getSkuInventoryDetails,
    getOrderDetails,
    getShipmentPackageQuantity,
    enterSalesDeliverDetail,

    notShipOrder,
    setCurrentShipmentId,
    setCurrentOrderId,
    setSalesOrderOnholdStatus,
    setFromMyOrderDetails,

    saveShippingPlan,
    getShippingPlanList,

    updateMyOrderDetails,
    getUploadFileLimit,
    uploadOffineFile,
    updateOrderProofs,
    updateMyOrderProofsLocal,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrderDetail);
